import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $verificationRequest,
  getVerificationRequests,
  verificationRequestMounted,
} from './model'

export const useVerificationRequestsWidget = (clientId: string) => {
  React.useEffect(() => {
    if (clientId) {
      verificationRequestMounted(clientId)
    }
  }, [clientId])

  const verificationRequest = useStore($verificationRequest)

  const loading = useStore(getVerificationRequests.pending)

  return {
    verificationRequest,
    loading,
  }
}
